import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/fees-mercari';

export default function Example() {
  return (
    <>
      <Head>
        <title>Everything You Need To Know About Mercari's Seller Fees</title>
        <meta
          name='description'
          content='Like any other online shopping destination, Mercari has fees that it charges its sellers. Find out what these fees are and how you can still get the best out of Mercari'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/fees-mercari' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/fees-mercari' />
        <meta property='og:title' content="Everything You Need To Know About Mercari's Seller Fees" />
        <meta
          property='og:description'
          content='Like any other online shopping destination, Mercari has fees that it charges its sellers. Find out what these fees are and how you can still get the best out of Mercari'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
